<template>
  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
    scrollable
  >
    <v-card class="pa-5">
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <v-card-text>
        <v-progress-circular
          v-if="loadingData"
          size="72"
          indeterminate
          class="text-center justify-center ma-8 d-block mx-auto"
        />  
        <v-form ref="form" v-model="valid" @submit.prevent>
          <!-- eslint-disable -->
          <!-- splited v-radio-group because was not able to add tooltip above whole v-radio section -->
          <v-radio-group
            v-model="sharingSettings"
            class="colored-options"
            data-testid="choose-sharing-options"
            v-if="type == 'activity'"
          >
            <v-radio
              v-for="option in sharingOptions"
              :key="option.id"
              :label="$t('activitySharingSettingsOption' + option.id)"
              :value="option.id"
              color="accent"
              class="black--text pa-5 option rounded-xxl mb-4"
              data-testid="sharing-setting-options"
              @change="changeSharingOption(option.id)"
              active-class="selected"
              :disabled="productPlan.attributes && productPlan.attributes.name == 'Free' && option.id != 1"
            >
              <template v-slot:label>
                <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free' && option.id != 1" class="rounded-lg pro-chip px-2" x-small color="accent" text-color="white">PRO</v-chip>
                <div class="option-slot-pro">
                  <span class="text-subtitle-1 font-weight-bold">{{
                    $t("activitySharingSettingsOptionTitle" + option.id)
                  }}</span
                  ><br />
                  <span
                    class="text-subtitle-2 grey--text font-weight-regular"
                    >{{
                      $t("activitySharingSettingsOptionText" + option.id)
                    }}</span>
                    <br />
                </div>
              </template>
            </v-radio>
          </v-radio-group>
           <v-radio-group
            v-model="sharingSettings"
            class="colored-options"
            data-testid="choose-sharing-options"
            v-else
          >
            <v-radio
              key="1"
              :label="$t('activitySharingSettingsOption1')"
              value="1"
              color="accent"
              class="black--text pa-5 option rounded-xxl mb-4"
              data-testid="sharing-setting-options-hub-1"
              @change="changeSharingOption(1)"
              active-class="selected"
            >
              <template v-slot:label>
                <div class="option-slot-pro">
                  <span class="text-subtitle-1 font-weight-bold">{{
                    $t("activitySharingSettingsOptionTitle1")
                  }}</span
                  ><br />
                    <span
                    class="text-subtitle-2 grey--text font-weight-regular"
                    >{{
                      $t("hubSharingSettingsOption1")
                    }}</span>
                  <br />
                </div>
              </template>
            </v-radio>
            <v-tooltip bottom :disabled="!autoShareWithActivities">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-radio
                    key="3"
                    :label="$t('activitySharingSettingsOption3')"
                    value="3"
                    color="accent"
                    class="black--text pa-5 option rounded-xxl mb-4"
                    data-testid="sharing-setting-options-hub-2"
                    @change="changeSharingOption(3)"
                    active-class="selected"
                    :disabled="autoShareWithActivities"
                  >
                    <template v-slot:label>
                      <div class="option-slot-pro">
                        <span class="text-subtitle-1 font-weight-bold">{{
                          $t("activitySharingSettingsOptionTitle3")
                        }}</span
                        ><br />
                          <span
                          class="text-subtitle-2 grey--text font-weight-regular"
                          >{{
                            $t("hubSharingSettingsOption3")
                          }}</span>
                        <br />
                      </div>
                    </template>
                  </v-radio>
                </div>
              </template>
            <span>{{ $t('autoShareHubPreventChangeSharingSettingTooltip') }}</span>
          </v-tooltip>
          </v-radio-group>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="darktext"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 cancel"
          :disabled="loading"
          @click="show = false"
        >
          {{ cdCancelBtn }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          type="submit"
          color="accent"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 submit"
          :loading="loading"
          @click="submitDialogBtn()"
        >
          {{ cdSubmitBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <ConfirmationDialog
      v-if="dialogVisibleChangeSharingSetting"
      ref="confirmationDialogChangeSharingSetting"
      :visible="dialogVisibleChangeSharingSetting"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-change-sharing-setting"
      cd-submit-btn-color="accent"
      @close="resetSharingSetting"
      @proceedSubmit="dialogVisibleChangeSharingSetting = false"
    />
  </v-dialog>
</template>
<script>
import i18n from "../plugins/i18n";
import { getSharingSetings } from "../api/activityApi";
import { getHubSharingSetings } from "../api/hubApi";
import ConfirmationDialog from "../components/ConfirmationDialog.vue";
export default {
  components: {
    ConfirmationDialog
  },
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: "",
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t("submit"),
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t("cancel"),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    activitySharingSettings: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "activity"
    },
    autoShareWithActivities: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: true,
      alertMsg: "",
      alertType: "",
      alertValue: false,
      loadingData: false,
      sharingOptions: [],
      dialogVisibleChangeSharingSetting: false,
      confirmationDialogTitle: this.type == 'activity' ? i18n.t(
        "confirmationDialogTitleChangeActivitySharingSetting"
      ) : i18n.t(
        "confirmationDialogTitleChangeHubSharingSetting"),
      confirmationDialogText: this.type == 'activity' ? i18n.t(
        "confirmationDialogTextChangeActivitySharingSetting"
      ): i18n.t(
        "confirmationDialogTextChangeHubSharingSetting"),
      confirmationDialogCancelBtn: i18n.t("cancel"),
      confirmationDialogSubmitBtn: i18n.t("ok"),
      valSharingSettings: ""
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
          this.$refs.form.reset();
        }
      },
    },
    sharingSettings: {
      get() {
        return this.valSharingSettings;
      },
      set(activitySharingSettings) {
        this.valSharingSettings = activitySharingSettings;
      },
    },
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  watch: {
    activitySharingSettings(newValsharing) {
      this.valSharingSettings = newValsharing;
    },
  },

  async created() {
    this.loadingData = true;
    this.fetchSharingSettings();
    this.sharingSettings = this.activitySharingSettings
    this.loadingData = false;
  },
  methods: {
    proceedSubmit() {
      this.$router.push({ path: "/space/subscription" });
    },
    submitDialogBtn() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.$emit("proceedSubmit", this.sharingSettings);
      }
    },
    async fetchSharingSettings() {
      try {
        var response = null
        if(this.type == 'activity'){
          response = await getSharingSetings();
          if (response) {
            if (response.status == 200) {
              this.sharingOptions = response.data.data;
            }
          }
        }else {
            response = await getHubSharingSetings()
            if(response){
                if(response.status == 200) {
                    this.sharingOptions = response.data.data
                }
            }      
        }
        
        if (response) {
          if (response.status == 200) {
            this.sharingOptions = response.data.data;
          }
        }
      } catch (e) {
        if (e.response) {
          this.$emit("proceedSubmit", null);

        }
      }
    },
    changeSharingOption(newVal) {
      if(this.type == 'activity'){
          if (newVal == 3 && this.activitySharingSettings != 3) {
              this.dialogVisibleChangeSharingSetting = true;
          }
      }else {
          if(newVal == 1 && this.activitySharingSettings != 1)
          {
              this.dialogVisibleChangeSharingSetting = true
          }
      }
      
    },
    resetSharingSetting() {
      this.sharingSettings = this.activitySharingSettings;
      this.dialogVisibleChangeSharingSetting = false;
    },
  },
};
</script>